export default "__VITE_ASSET__1N44qcc2__"